import React from "react";
import { Phone, Mail, Globe } from "lucide-react";

export default function ContactSection() {
  return (
    <section className="bg-[#0d1728] py-20" id="contact">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-1 gap-20 lg:grid-cols-2">
          {/* Left Side */}
          <div>
            <p className="uppercase text-sm font-semibold text-[#b8903c]">
              Get In Touch
            </p>

            <h2 className="mt-4 text-5xl leading-tight text-white font-light">
              Let's structure the right deal
              <br />
              for you
            </h2>

            <p className="mt-6 max-w-xl text-sm leading-8 text-gray-500">
              Whether you are raising your first tranche or refinancing a
              complex capital structure, we are here to help. Reach out to begin
              the conversation.
            </p>

            {/* Contact Info */}

            <div className="mt-14 space-y-8">
              {/* Phone */}

              <div className="flex items-start gap-5">
                <div className="flex h-10 w-10 items-center justify-center border border-[#c9a84c59]">
                  <Phone className="h-6 w-6 text-[#d3af47]" />
                </div>

                <div>
                  <p className="text-[10px] uppercase  text-gray-500">Phone</p>

                  <a
                    href="tel:+917007321766"
                    className="mt-2 inline-block text-sm text-[#e8c97a]"
                  >
                    +91 7007321766
                  </a>
                </div>
              </div>

              {/* Email */}

              <div className="flex items-start gap-5">
                <div className="flex h-10 w-10 items-center justify-center border border-[#c9a84c59]">
                  <Mail className="h-6 w-6 text-[#e8c97a]" />
                </div>

                <div>
                  <p className="text-[10px] uppercase  text-gray-500">Email</p>

                  <a
                    href="mailto:info@ybcapital.in"
                    className="mt-2 inline-block text-sm text-[#e8c97a]"
                  >
                    info@ybcapital.in
                  </a>
                </div>
              </div>

              {/* Website */}

              <div className="flex items-start gap-5">
                <div className="flex h-10 w-10 items-center justify-center border border-[#c9a84c59]">
                  <Globe className="h-6 w-6 text-[#e8c97a]" />
                </div>

                <div>
                  <p className="text-[10px] uppercase  text-gray-500">
                    Website
                  </p>

                  <a
                    href="https://ybcapital.in"
                    target="_blank"
                    className="mt-2 inline-block text-sm text-[#e8c97a]"
                  >
                    https://ybcapital.in
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side */}

          <form className="space-y-7">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
              <div>
                <label className="mb-2 block text-[12px] uppercase  text-gray-400">
                  Full Name
                </label>

                <input
                  type="text"
                  placeholder="Your name"
                  className="h-12 w-full border border-[#2b374b] bg-[#1a2537] px-5 text-white placeholder:text-gray-500 focus:border-[#d3af47] focus:outline-none"
                />
              </div>

              <div>
                <label className="mb-2 block text-[12px] uppercase  text-gray-400">
                  Company
                </label>

                <input
                  type="text"
                  placeholder="Company name"
                  className="h-12 w-full border border-[#2b374b] bg-[#1a2537] px-5 text-white placeholder:text-gray-500 focus:border-[#d3af47] focus:outline-none"
                />
              </div>
            </div>

            <div>
              <label className="mb-2 block text-[12px] uppercase  text-gray-400">
                Email Address
              </label>

              <input
                type="email"
                placeholder="you@company.com"
                className="h-12 w-full border border-[#2b374b] bg-[#1a2537] px-5 text-white placeholder:text-gray-500 focus:border-[#d3af47] focus:outline-none"
              />
            </div>

            <div>
              <label className="mb-2 block text-[12px] uppercase  text-gray-400">
                Phone
              </label>

              <input
                type="tel"
                placeholder="+91 XXXXX XXXXX"
                className="h-12 w-full border border-[#2b374b] bg-[#1a2537] px-5 text-white placeholder:text-gray-500 focus:border-[#d3af47] focus:outline-none"
              />
            </div>

            <div>
              <label className="mb-2 block text-[12px] uppercase  text-gray-400">
                Type of Requirement
              </label>

              <select className="h-12 w-full border border-[#2b374b] bg-[#1a2537] px-5 text-white focus:border-[#d3af47] focus:outline-none">
                <option>Select capital requirement</option>
                <option>Debt Funding</option>
                <option>Equity Funding</option>
                <option>Working Capital</option>
                <option>Project Finance</option>
                <option>Structured Finance</option>
              </select>
            </div>

            <div>
              <label className="mb-2 block text-[12px] uppercase  text-gray-400">
                Brief Requirement
              </label>

              <textarea
                rows={3}
                placeholder="Describe your funding requirement, quantum, and timeline..."
                className="w-full border border-[#2b374b] bg-[#1a2537] p-5 text-white placeholder:text-gray-500 focus:border-[#d3af47] focus:outline-none"
              />
            </div>

            <button
              type="submit"
              className="bg-[#d3af47] px-10 py-3 text-sm font-semibold uppercase  text-black transition hover:bg-[#be9c39]"
            >
              Send Enquiry
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
